import { useCallback } from 'react';

import { x } from '@/style';

import { SurveyType } from '@graphql/requests';

import { useAnalyticsReportingService } from '@ui-furniture/common/analytics';
import { Card, Text, VStack } from '@ui-furniture/elements';
import { useStateModalControls } from '@ui-furniture/lib/modal';
import { currencyFormatter } from '@ui-furniture/lib/utils/data-transform/currency-formatter';

// eslint-disable-next-line import/no-cycle
import { BookSpecialistSurveyModal } from './book-specialist-survey-modal';

import { useSurveyRecommendation } from '../context/survey-recommendation';

export const SpecialistSurveyCard = ({
  name,
  type,
  price,
  imageUrl,
}: {
  name: string;
  type: SurveyType;
  price: number | null;
  description: string;
  explanation: string;
  imageUrl: string;
}) => {
  const { reportObjective } = useAnalyticsReportingService();
  const modalControls = useStateModalControls({
    onOpen: () => {
      reportObjective({
        category: 'Survey',
        stage: 'event',
        name: 'Survey - Open Book Survey Modal',
        data: {
          name,
          surveyType: type,
          price,
        },
      });
    },
  });
  const { ensureFormIsComplete } = useSurveyRecommendation();
  const requestBookSurvey = useCallback(async () => {
    const isFormComplete = await ensureFormIsComplete();
    if (isFormComplete) modalControls.open();
  }, [ensureFormIsComplete]);

  return (
    <>
      <BookSpecialistSurveyModal controls={modalControls} type={type} />
      <Card clickStyleVariant='scale' onClick={requestBookSurvey} w='100%'>
        <x.div
          display='flex'
          alignItems='center'
          position='relative'
          p='lg'
          h='100%'
          overflow='hidden'
          borderRadius='5px'
        >
          <x.img
            src={imageUrl}
            alt={name}
            objectFit={'cover'}
            width='100%'
            height='100%'
            position='absolute'
            top='0'
            right='0'
            left='0'
            bottom='0'
          />
          <x.img
            src={'/images/survey/white-gradient-overlay.png'}
            objectFit={'cover'}
            position='absolute'
            width='100%'
            height='100%'
            top='0'
            right='0'
            left='0'
            bottom='0'
          />
          <VStack position='relative' gap='xs'>
            <Text lineHeight='1' fontWeight='500' fontSize='lg'>
              {name}
            </Text>
            <Text fontSize='md' fontWeight='500' color='palette-primary'>
              {price ? currencyFormatter.format(price) : 'Price on Request'}
            </Text>
          </VStack>
        </x.div>
      </Card>
    </>
  );
};
